import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import {
  Title,
  Text,
  Margin,
  Input,
  Button,
  Loading,
  ErrorMessage,
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function FormForgot() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const success = useSelector(
    (state) => state.authentication.forgotPass.success
  );
  const sending = useSelector(
    (state) => state.authentication.forgotPass.sending
  );
  const errorMessage = useSelector(
    (state) => state.authentication.forgotPass.errorMessage
  );
  const initialValues = {
    Email: "",
  };

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;

  useEffect(() => {
    dispatch(AuthenticationActions.sendForgotPasswordReset());
    return () => {
      dispatch(AuthenticationActions.sendForgotPasswordReset());
    };
  }, [dispatch]);
  return (
    <S.FormHolder>
      <Margin mt={mobile ? 6 : 12} mb={mobile ? 3 : 4}>
        <Title as="1" levelDesktop="3" level="4" emphasis={false}>
          ¿Olvidaste tu <br className="mobileOnly" />
          contraseña?
        </Title>
      </Margin>
      <Margin mb={4}>
        <Text level="1">
          Si has olvidado tu contraseña, introduce la dirección de correo
          electrónico que utilizaste en el registro para recibir tu nueva
          contraseña.
        </Text>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(
              AuthenticationActions.sendForgotPassword({ ...values, url: url })
            );
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <Margin mb={mobile ? 3 : 4}>
                <Input
                  label="Correo electrónico"
                  placeholder="Ingrese su correo electrónico registrado"
                  htmlFor="emailFieldFormForgot"
                  name="Email"
                  value={values.Email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={errors.Email && touched.Email && errors.Email}
                  valid={!errors.Email && touched.Email && !errors.Email}
                  required
                />
                {errorMessage && (
                  <Margin mt={3} mb={3}>
                    {!success ? (
                      <ErrorMessage inset>{errorMessage}</ErrorMessage>
                    ) : (
                      <S.SuccessMessage>{errorMessage}</S.SuccessMessage>
                    )}
                  </Margin>
                )}
              </Margin>
              <S.ButtonHolder>
                <Button
                  className="animation-size"
                  color={!isValid || !dirty || sending ? "disabled" : "primary"}
                  type="submit"
                  disabled={!isValid || !dirty || sending}
                  id="sendButtonFormForgot"
                >
                  {sending ? <Loading button /> : "ENVIAR"}
                </Button>
              </S.ButtonHolder>
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
      <Margin mb={mobile ? 5 : 12}>
        <S.TextHolder>
          <Text level="1">
            <span
              onClick={() => history.push("/login")}
              id="backLinkFormForgot"
            >
              Atrás para iniciar sesión
            </span>
          </Text>
        </S.TextHolder>
      </Margin>
    </S.FormHolder>
  );
}
